import { observer } from 'mobx-react';
import { FC } from 'react';
import { marketplaceFilterCrumbs } from '../../constants/marketplace';
import marketplaceStore from '../../store/marketplaceStore';
import { MarketplaceFeatureType } from '../../types/marketplace';
import { Checkbox } from '~/view/components/Controls/Checkbox/Checkbox';
import Crumbs from '~/view/components/Controls/Crumbs';
import SearchInput from '~/view/components/Controls/SearchInput/SearchInput';
import './style.scss';

const MarketplaceFilters: FC = observer((): JSX.Element => {
  const handleSearch = (value: string | undefined) => {
    marketplaceStore.changeFilters({ search: value });
  };

  const handleCrumbClick = (value: MarketplaceFeatureType) => {
    marketplaceStore.changeFilters({ type: value, search: '' });
  };

  const handlePurchasedCheckbox = (name: string | number, value: boolean | undefined) => {
    marketplaceStore.changeFilters({ showPurchased: !value });
  };

  return (
    <div className="d-flex flex-column mt-6 pr-4">
      <SearchInput
        value={marketplaceStore.filters.search}
        customPlaceholder
        placeholder="txt_search"
        className="w-fit-content"
        inputClassName="marketplace-filters__search-input"
        withResetIcon
        onChangeText={handleSearch}
      />
      <div className="d-flex justify-content-between align-items-center mt-6">
        <Crumbs crumbs={marketplaceFilterCrumbs} activeCrumb={marketplaceStore.filters.type} translateLabel onClick={handleCrumbClick} />
        <Checkbox name="show" value={marketplaceStore.filters.showPurchased} label="show_purchased" onClick={handlePurchasedCheckbox} />
      </div>
    </div>
  );
});

export default MarketplaceFilters;
